import { Checkbox, TableCell, TableRow, TableSortLabel } from '@mui/material';
import React from 'react';
/**
 * Renders the header row for a data table, including optional multi-select checkbox,
 * sortable columns, and a menu column if specified.
 *
 * @template T - The row data type used for sorting and column definitions.
 * @param {Props<T>} props - The props for rendering table headers including columns, sort state, and selection controls.
 * @returns {React.ReactElement} The rendered table header row.
 */
export function Head(props) {
    return (React.createElement(TableRow, null,
        props.multiSelect && (React.createElement(TableCell, { padding: 'checkbox' },
            React.createElement(Checkbox, { color: 'primary', indeterminate: props.multiSelectState === 1, checked: props.multiSelectState === 2, onChange: props.onToggleSelectAll, "data-test": 'select-all-checkbox' }))),
        props.columns.map((column) => {
            const columnName = column.name;
            return (React.createElement(TableCell, { key: columnName, sx: { width: column.width }, "data-test": `${columnName}-header` }, column.sortable && columnName ? (React.createElement(TableSortLabel, { active: props.sortColumnName === columnName, direction: props.sortDesc ? 'desc' : 'asc', onClick: () => props.onChangeSort(column, props.sortColumnName === columnName ? !props.sortDesc : props.sortDesc) }, column.label)) : (column.label)));
        }),
        props.menu && React.createElement(TableCell, { style: { width: 80 }, "data-test": 'menu-header' })));
}
